<template>

  <div class="container-fluid" id="error-content" v-if="this.$store.state.error">
    <div class="row">
      <div class="col-md-2"></div>
      <div class="col-md-8">
        <div class="alert alert-danger">
          <button type="button" class="close" @click="close()"><span aria-hidden="true">&times;</span><span class="sr-only">Close</span></button>
          <strong>Error!</strong> {{ this.$store.state.errorMessage }}
        </div>
      </div>
      <div class="col-md-2"></div>
    </div>
  </div>

</template>

<script>
export default {
    name: 'prv-error-message',
    methods: {
        close (){
          this.$store.dispatch('hideMessageError');
        }
    }
}
</script>

<style scoped>
  #error-content {
    margin-top: 20px;
  }
</style>